import Typography from '@app/components/atoms/Typography';
import styled from 'styled-components';
import { deviceSizes } from '@app/config/devices';

export const ImageContainer = styled.div`
  margin-right: 1rem;
  margin-bottom: 1rem;
  display: flex;
  width: 30%;
  height: 130px;
  align-items: center;
  justify-content: center;
  img {
    border-radius: 6px;
    width: 100%;
    height: 100%;
  }
  position: relative;
  @media (max-width: ${deviceSizes.tablet}) {
    margin-right: 10px;
    margin-bottom: 10px;
  }
  @media (max-width: ${deviceSizes.sm}) {
    margin-right: 5px;
    margin-bottom: 5px;
  }
  @media (max-width: ${deviceSizes.mobileL}) {
    height: 90px;
  }
`;

export const LightboxContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;

`;

export const StyledTypography = styled(Typography)`
  && {
    position: absolute;
    color: white;
    font-weight: bold;
    cursor: pointer;
    &:hover{
      text-decoration: underline;
    }
  }
`;

export const StyledIconBox = styled.div`
  position: absolute;
  bottom: 0;
  right: 10px;
  svg:hover {
    fill: ${({ theme }) => theme.primary.main};
    cursor: pointer;
  }
`;
